<button (click)="signOut()">تسجيل الخروج</button>
